<template>
  <div>
    <modal-crear-editar
      :configuracion="configuracion_modal"
      @realizado="restablecer_inputs"
    ></modal-crear-editar>
    <tablita
      :cols="columnas"
      @cargar="cargar($event)"
      @cargar_url="cargar_url($event)"
      @nuevo="crear"
      @editar="editar($event)"
      :configuracion="configuracion_tabla"
      @refresh="refrescar($event)"
    ></tablita>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "rut",
        label: "Rut",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "rut",
      },
      {
        key: "nombres",
        label: "Nombre",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "nombres",
      },
      {
        key: "apellidos",
        label: "Apellido",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "apellidos",
      },
      {
        key: "pasaporte",
        label: "Pasaporte",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "pasaporte",
      },
      {
        key: "telefono",
        label: "Teléfono",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "telefono",
      },
      {
        key: "email",
        label: "Email",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "email",
      },
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      {
        cols: 4,
        tipo: "texto",
        key: "rut",
        valor: "",
        label: "Rut (*)",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "nombres",
        valor: "",
        label: "Nombres (*)",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "apellidos",
        valor: "",
        label: "Apellidos (*)",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "pasaporte",
        valor: "",
        label: "Pasaporte (*)",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "telefono",
        valor: "",
        label: "Teléfono",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "email",
        valor: "",
        label: "Email",
        disabled: false,
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Conductor",
      ancho: "xl",
      ruta: "/conductores",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Conductores",
      titulo_boton: "Crear Conductor",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    pagina_actual: "",
    /* columns: [
            {label: 'Rut', field: 'rut'},
            {label: 'Nombre', field: 'nombre', headerClass: 'class-in-header second-class'}
        ], */
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    this.$emit("spinner", true);
    //this.cargar("");
    this.$emit("cargar");
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar($event) {
      this.$emit("spinner", true);
      this.pagina_actual = `${this.api}/conductores${$event}`;
      this.lista = [];
      await this.axios
        .get(`${this.api}/conductores${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
      this.$emit("spinner", false);
    },
    async cargar_url(url) {
      if (url) {
        this.$emit("spinner", true);
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
        this.$emit("spinner", false);
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/conductores`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/conductores/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },
    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>